module.exports = __webpack_public_path__ + "static/media/basket.2d16e964.svg";